"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ResultWithOverview_1 = require("../ResultWithOverview");

var OverviewConverterImpl_1 = require("./OverviewConverterImpl");

var ResultWithOverviewConverter_1 = require("./ResultWithOverviewConverter");
/**
 * Default implementation of {@link ResultWithOverviewConverter}.
 *
 * @author Radek Beran
 */


var ResultWithOverviewConverterImpl =
/*#__PURE__*/
function (_ResultWithOverviewCo) {
  _inherits(ResultWithOverviewConverterImpl, _ResultWithOverviewCo);

  function ResultWithOverviewConverterImpl(itemConverter, filterConverter) {
    var _this;

    _classCallCheck(this, ResultWithOverviewConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResultWithOverviewConverterImpl).call(this));
    _this.itemConverter = itemConverter;
    _this.overviewConverter = new OverviewConverterImpl_1.OverviewConverterImpl(filterConverter);
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ResultWithOverviewConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ResultWithOverview_1.ResultWithOverview(conversions.asObjectList(source, 'result', function (doc) {
        return _this2.itemConverter.toObject(doc, conversions);
      }), conversions.asObject(source, 'overview', function (doc) {
        return _this2.overviewConverter.toObject(doc, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {};
      Object.assign(document, {
        result: conversions.asObjectArray(source, 'result', function (item) {
          return _this3.itemConverter.toDocument(item, conversions);
        }),
        overview: this.overviewConverter.toDocument(source.overview, conversions)
      });
      return document;
    }
  }]);

  return ResultWithOverviewConverterImpl;
}(ResultWithOverviewConverter_1.ResultWithOverviewConverter);

exports.ResultWithOverviewConverterImpl = ResultWithOverviewConverterImpl;